module.exports = __webpack_public_path__ + "static/media/wallet_onboarding_01.b356609e.svg";